<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="relative z-10" @close="closeButtonExists && emit('update:open', false)">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                       leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 transition-opacity" :class="[notTransparent ? 'bg-gray-100' : 'bg-gray-500 bg-opacity-75']"/>
      </TransitionChild>
      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
                           enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                           enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                           leave-from="opacity-100 translate-y-0 sm:scale-100"
                           leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
                class="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:p-6"
                :class="[isSmall ? 'sm:max-w-lg' : 'sm:max-w-3xl']">
              <div v-if="closeButtonExists" class="flex justify-end mr-[-12px] mt-[-12px]">
                <XIcon class="h-6 w-6 cursor-pointer" @click="emit('update:open', false)" aria-hidden="true"/>
              </div>
              <slot></slot>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import {Dialog, DialogPanel, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {
  XIcon,
} from '@heroicons/vue/outline'

defineProps({
  open: {
    type: Boolean,
    default: false
  },
  notTransparent: {
    type: Boolean,
    default: true,
  },
  closeButtonExists: {
    type: Boolean,
    default: true,
  },
  isSmall: {
    type: Boolean,
    default: false,
  }
});

const emit = defineEmits(['update:open']);

</script>
